// 立即咨询
export const CONSULT_IMMEDIATELY = {
	'HK': '立即諮詢',
	'ZH': '立即咨询',
	'EN': 'Consult Immediately'
}

// 重点皇牌眼部项目
export const KEY_HUANGPAI_EYE_PROJECT = {
	'HK': '重點皇牌眼部項目',
	'ZH': '重点皇牌眼部项目',
	'EN': 'Key Huangpai Eye Project'
}

// 了解其他治療的更多信息
export const LEARN_MORE_ABOUT_OTHER_TREATMENTS = {
	'HK': '了解其他治療的更多信息',
	'ZH': '了解其他治疗的更多信息',
	'EN': 'Learn More About Other Treatments'
}

// 眼部知識知多的
export const HAVING_EXTENSIVE_KNOWLEDGE_ABOUT_THE_EYES = {
	'HK': '健康知識知多啲',
	'ZH': '健康知识知多啲',
	'EN': 'Having Extensive Knowledge About The Eyes'
}

// 星级代言人实证
export const EMPIRICAL_EVIDENCE_OF_STAR_ENDORSERS = {
	'HK': '星級代言人實證',
	'ZH': '星级代言人实证',
	'EN': 'Empirical Evidence Of Star Endorsers'
}

// 查看更多
export const MORE = {
	'HK': '查看更多',
	'ZH': '查看更多',
	'EN': 'See More'
}

// 首页-关于我们-标题
export const HOME_ABOUTUS_TITLE = {
	'HK': 'KINLY健麗',
	'ZH': 'KINLY健丽',
	'EN': 'Kinly'
}

// 首页-关于我们-副标题
export const HOME_ABOUTUS_SUBTITLE = {
	'HK': '眼袋专家',
	'ZH': '眼袋專家',
	'EN': 'Eye Bag Expert'
}

// 首页-关于我们-走進健麗
export const HOME_ABOUTUS_ENTERING_KINLY = {
	'HK': '走进健丽',
	'ZH': '走進健麗',
	'EN': 'Entering Kinly'
}

// 首页-关于我们-我們的理念
export const HOME_ABOUTUS_OUR_PHILOSOPHY = {
	'HK': '關於KINLY健麗',
	'ZH': '关于KINLY健丽',
	'EN': 'Our Philosophy'
}

// 姓名
export const FULL_NAME = {
	'HK': '姓名',
	'ZH': '姓名',
	'EN': 'Full Name'
}

// 電話
export const PHONE = {
	'HK': '電話',
	'ZH': '电话',
	'EN': 'Phone'
}

// 性別
export const SEX = {
	'HK': '性別',
	'ZH': '性別',
	'EN': 'Sex'
}

// 年齡
export const AGE = {
	'HK': '年齡',
	'ZH': '年龄',
	'EN': 'Age'
}

// 預約時間:
export const APPOINTMENT_TIME = {
	'HK': '預約日期',
	'ZH': '预约日期',
	'EN': 'Appointment Time'
}

// 選擇療程/需要治療的問題
export const APPOINTMENT_REBUFUND = {
	'HK': '選擇療程/需要治療的問題',
	'ZH': '选择疗程/需要治疗的问题',
	'EN': 'Appointment Rebufund'
}

// 关于我们
export const ABOUT_US_CHENNEL = {
	'HK': {
		title: '關於我們',
		subtitle: 'ABOUT US'
	},
	'ZH': {
		title: '關於我們',
		subtitle: 'ABOUT US'
	},
	'EN': {
		title: '關於我們',
		subtitle: 'ABOUT US'
	}
}

// 关于我们
export const ABOUT_US_DESC = {
	'HK': [{
		title: '30',
		subtitle: '年',
		desc: '專注眼部年輕化',
		remark: 'KINLY健麗30年專注於眼部年輕化、去眼袋技術引領潮流，擁有經驗豐富的專業醫師團隊，更值得信賴。'
	}, {
		title: '20',
		subtitle: '+',
		desc: '眼部治療專利技術',
		remark: '自由眼部治療專利技術超過20種，實屬市場罕見。合約保證一次性去眼袋效果長達20年之久'
	}, {
		title: '20',
		subtitle: '萬',
		desc: '真實用戶案例',
		remark: '逾20萬真實用戶案例，還有衆多明星藝人實證。治療過程更放心。'
	}],
	'ZH': [{
		title: '30',
		subtitle: '年',
		desc: '专注眼部年轻化',
		remark: 'KINLY健麗30年專注於眼部年輕化、去眼袋技術引領潮流，擁有經驗豐富的專業醫師團隊，更值得信賴。'
	}, {
		title: '20',
		subtitle: '+',
		desc: '眼部治疗专利技术',
		remark: '自由眼部治療專利技術超過20種，實屬市場罕見。合約保證一次性去眼袋效果長達20年之久'
	}, {
		title: '20',
		subtitle: '万',
		desc: '真实用户案例',
		remark: '逾20萬真實用戶案例，還有衆多明星藝人實證。治療過程更放心。'
	}],
	'EN': [{
		title: '30',
		subtitle: 'Year',
		desc: 'Focusing On Rejuvenating The Eyes',
		remark: 'KINLY健麗30年專注於眼部年輕化、去眼袋技術引領潮流，擁有經驗豐富的專業醫師團隊，更值得信賴。'
	}, {
		title: '20',
		subtitle: '+',
		desc: 'Patent Technology For Eye Treatment',
		remark: '自由眼部治療專利技術超過20種，實屬市場罕見。合約保證一次性去眼袋效果長達20年之久'
	}, {
		title: '20',
		subtitle: 'Ten Thousand',
		desc: 'Real User Cases',
		remark: '逾20萬真實用戶案例，還有衆多明星藝人實證。治療過程更放心。'
	}]
}

// 發展歷程
export const DEVELOPMENT_HISTORY = {
	'HK': '發展歷程',
	'ZH': '发展历程',
	'EN': 'Development History'
}

// 联系我们
export const CONTACT_US_DESC = {
	'HK': ['服務熱線', '郵箱', '地圖', '預約體驗'],
	'ZH': ['服务热线', '邮箱', '地图', '预约体验'],
	'EN': ['Service Hotline', 'Email', 'Map', 'Select Treatment Course']
}

// 联系我们
export const CONTACT_US_CONSULTATION_HOTLINE = {
	'HK': '諮詢熱線',
	'ZH': '諮詢热线',
	'EN': 'Sonsultation Hotline'
}

// 联系我们
export const CONTACT_US_SERVICE_HOTLINE = {
	'HK': '服務熱線',
	'ZH': '服务热线',
	'EN': 'Service Hotline'
}

// 联系我们
export const CONTACT_US = {
	'HK': '聯繫我們',
	'ZH': '联系我们',
	'EN': 'Contact Us'
}

// 知多啲
export const HELP_CHENNEL = {
	'HK': {
		title: '知多啲',
		subtitle: 'KNOW MORE'
	},
	'ZH': {
		title: '知多的',
		subtitle: 'KNOW MORE'
	},
	'EN': {
		title: '知多的',
		subtitle: 'KNOW MORE'
	}
}

// 海报页-实力认证
export const POSTER_STRENGTH_CERTIFICATION = {
	'HK': '實力認證',
	'ZH': '实力认证',
	'EN': 'Strength Certification'
}

// 海报页-实力认证
export const POSTER_STRENGTH_CERTIFICATION_DESC = {
	'HK': [{
		title: '20',
		subtitle: '+',
		desc: '自家專利技術',
		remark: '部分眼部療程，擁有自家專利技術並提供長達20年效果合約保證,實屬罕見'
	}, {
		title: '29',
		subtitle: '年',
		desc: '專注去眼袋',
		remark: 'KINLY健麗29年一直專注眼部治療去眼袋技術引領潮流新一代技術承諾為你繼續提供安全及優質的服務體驗'
	}, {
		title: '20',
		subtitle: '萬',
		desc: '真實客戶案例實證',
		remark: '20萬+真實客戶案例   兼眾多藝人星級實證   治療過程更安心'
	}],
	'ZH': [{
		title: '20',
		subtitle: '+',
		desc: '自家专利技术',
		remark: '部分眼部疗程，拥有自家专利技术并提供长达20年效果合约保证,实属罕见'
	}, {
		title: '29',
		subtitle: '年',
		desc: '专注去眼袋',
		remark: 'KINLY健丽29年一直专注眼部治疗去眼袋技术引领潮流新一代技术承诺为你继续提供安全及优质的服务体验'
	}, {
		title: '20',
		subtitle: '万',
		desc: '真实客户案例实证',
		remark: '20万+真实客户案例   兼众多艺人星级实证   治疗过程更安心'
	}],
	'EN': [{
		title: '20',
		subtitle: '+',
		desc: 'Our Own Patented Technology',
		remark: '部分眼部疗程，拥有自家专利技术并提供长达20年效果合约保证,实属罕见'
	}, {
		title: '29',
		subtitle: 'Year',
		desc: 'Focus On Removing Eye Bags',
		remark: 'KINLY健丽29年一直专注眼部治疗去眼袋技术引领潮流新一代技术承诺为你继续提供安全及优质的服务体验'
	}, {
		title: '20',
		subtitle: 'Ten Thousand',
		desc: 'Empirical Analysis Of Real Customer Cases',
		remark: '20万+真实客户案例   兼众多艺人星级实证   治疗过程更安心'
	}]
}

// 海报页-星级艺人分享
export const POSTER_STAR_RATED_ARTIST_SHARING = {
	'HK': '星級藝人分享',
	'ZH': '星级艺人分享',
	'EN': 'Star Rated Artist Sharing'
}

// 海报页-真實客戶實證
export const POSTER_REAL_USER_SHARING = {
	'HK': '真實客戶實證',
	'ZH': '真实用户实证',
	'EN': 'Real User Sharing'
}

// 海报页-真實客戶實證
export const POSTER_BEFORE_TREATMENT = {
	'HK': '療效前',
	'ZH': '疗效前',
	'EN': 'Before Treatment'
}

// 海报页-真實客戶實證
export const POSTER_AFTER_TREATMENT = {
	'HK': '療效後',
	'ZH': '疗效后',
	'EN': 'After Treatment'
}

// 海报页-真實客戶實證
export const POSTER_REAL_USER_REFLECTIONS = {
	'HK': '用家心得',
	'ZH': '用家心得',
	'EN': 'Real User Reflections'
}

// 海报页-真實客戶實證
export const POSTER_REAL_USER_REFLECTIONS_AGE = {
	'HK': '歲',
	'ZH': '岁',
	'EN': 'Age'
}

// 海报页-真實客戶實證
export const SERVICE_DETAIL_CONTENT_TITLE = {
	'HK': '專利介紹',
	'ZH': '专利介绍',
	'EN': 'Patent Introduction'
}

// 海报页-真實客戶實證
export const SERVICE_DETAIL_CONTENT_CHOOSE_TITLE = {
	'HK': '爲何選擇',
	'ZH': '为何选择',
	'EN': 'Why Choose'
}

// 海报页-真實客戶實證
export const SERVICE_DETAIL_CONTENT_CHOOSE_SUBTITLE = {
	'HK': 'KINLY 健麗',
	'ZH': '为何选择',
	'EN': 'Why Choose'
}

// 海报页-真實客戶實證
export const SERVICE_DETAIL_CONTENT_CHOOSE_EFFECT = {
	'HK': '想要以下治療效果？',
	'ZH': '想要以下治疗效果？',
	'EN': 'Do You Want The Following Eye Bag Treatment Effects?'
}

// 预约
export const BOOKING_FORM_TITLE = {
	'HK': '立即登記',
	'ZH': '立即登记？',
	'EN': 'Do You Want The Following Eye Bag Treatment Effects?'
}

export default {
	CONSULT_IMMEDIATELY,
	KEY_HUANGPAI_EYE_PROJECT,
	LEARN_MORE_ABOUT_OTHER_TREATMENTS,
	HAVING_EXTENSIVE_KNOWLEDGE_ABOUT_THE_EYES,
	EMPIRICAL_EVIDENCE_OF_STAR_ENDORSERS,
	MORE,
	HOME_ABOUTUS_TITLE,
	HOME_ABOUTUS_SUBTITLE,
	HOME_ABOUTUS_ENTERING_KINLY,
	HOME_ABOUTUS_OUR_PHILOSOPHY,
	FULL_NAME,
	PHONE,
	SEX,
	AGE,
	APPOINTMENT_TIME,
	APPOINTMENT_REBUFUND,
	ABOUT_US_CHENNEL,
	ABOUT_US_DESC,
	DEVELOPMENT_HISTORY,
	CONTACT_US_DESC,
	CONTACT_US_CONSULTATION_HOTLINE,
	CONTACT_US_SERVICE_HOTLINE,
	CONTACT_US,
	HELP_CHENNEL,
	POSTER_STRENGTH_CERTIFICATION,
	POSTER_STRENGTH_CERTIFICATION_DESC,
	POSTER_STAR_RATED_ARTIST_SHARING,
	POSTER_REAL_USER_SHARING,
	POSTER_BEFORE_TREATMENT,
	POSTER_AFTER_TREATMENT,
	POSTER_REAL_USER_REFLECTIONS,
	POSTER_REAL_USER_REFLECTIONS_AGE,
	SERVICE_DETAIL_CONTENT_TITLE,
	SERVICE_DETAIL_CONTENT_CHOOSE_TITLE,
	SERVICE_DETAIL_CONTENT_CHOOSE_SUBTITLE,
	SERVICE_DETAIL_CONTENT_CHOOSE_EFFECT,
	BOOKING_FORM_TITLE
}


// WEBPACK FOOTER //
// ./src/api/constant.js